export default __webpack_public_path__ + "static/assets/1634588e729f12cc85732f3dfb87912c.gif";